export enum RackHeightUnit {
  HE = "HE",
  MM = "mm",
}
